import { BookOpenCheckIcon, CalculatorIcon, ClipboardCheckIcon, FlameIcon, ScanSearchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Concrete Mix Design & Calculations Quick-Reference',
    description: 'Key formulas, step sequences and worked calculations for proportioning concrete, gathered in one quick reference.',
    icon: CalculatorIcon,
  },
  {
    number: '2',
    title: 'Concrete Field Testing & Pour Inspection Checklists',
    description: 'Checklists for fresh concrete tests, specimen handling and inspections before, during and after the pour.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '3',
    title: 'Concrete Cracks & Defects Identification Guide',
    description: 'A visual guide to common crack patterns and surface defects and their typical causes.',
    icon: ScanSearchIcon,
  },
  {
    number: '4',
    title: "Cement Kiln & Clinker Quality Operator's Pocket Guide",
    description: 'A compact reference to kiln operating parameters, clinker quality indicators and common process upsets.',
    icon: FlameIcon,
  },
  {
    number: '5',
    title: 'Cement & Concrete Terminology Dictionary',
    description: 'An A–Z reference of the terms and acronyms used in cement manufacturing, concrete technology, testing and quality.',
    icon: BookOpenCheckIcon,
  },
];
